import React, { useState, useEffect } from 'react';
import useOutsideClick from '../../../hooks/useClickOutside';

const SearchBox = props => {
  const {
    placeholder = '',
    controller,
    useButton = true,
    showIcon = false,
    allowEmptyQueries = false
  } = props;
  const [state, setState] = useState(controller.state);
  const [expanded, setExpanded] = useState(false);
  const isEnterKey = e => e.key === 'Enter';

  useEffect(() => {
    controller.subscribe(() => {
      setState(controller.state);
      const { redirectTo, value, analytics } = controller.state;
      if (redirectTo) {
        const { redirectTo, value, analytics } = controller.state;
        const data = JSON.stringify({ value, analytics });
        localStorage.setItem('coveo_standalone_search_box_data', data);
        window.location.href = redirectTo;
        return null;
      }
    });
  }, []);

  const handleQuerySubmit = e => {
    if (e.target.value.length === 0 && !allowEmptyQueries) {
      return;
    }

    submitGoogleEvent(controller.state.value);

    controller.submit();
  };

  const ref = useOutsideClick(() => {
    setExpanded(false);
  });

  const submitGoogleEvent = (searchTerm) => {
    const eventData = {
      event: "search",
      detailed_event: "Search",
      event_data: {
        identifier: "site_search",
        name: "site_search",
        corrected_term: searchTerm,
        search_term: searchTerm,
        search_type: "site_search"
      }
    };
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_data: null });
    window.dataLayer.push(eventData);
  };

  return (
    <div className="fields__wrapper">
      <div className="field">
        <div className="field__input-label-wrapper">
          <div className="field__input-and-icon" ref={ref}>
            {showIcon && (
              <svg
                viewBox="0 0 31 33"
                width="31"
                height="33"
                role="presentation"
              >
                <use xlinkHref="#search"></use>
              </svg>
            )}
            <input
              className="field__input"
              value={state.value}
              onChange={e => {
                if (e.target.value.length > 0 && !expanded) {
                  setExpanded(true);
                }
                controller.updateText(e.target.value);
              }}
              onKeyDown={e => isEnterKey(e) && handleQuerySubmit(e)}
              placeholder={placeholder}
            />
          </div>
          {state.suggestions.length > 0 && expanded && (
            <ul className="field__input-suggestions">
              {state.suggestions.map(suggestion => {
                const value = suggestion.rawValue;
                return (
                  <li
                    className="field__input-suggestion"
                    key={value}
                    onClick={() => { submitGoogleEvent(value); controller.selectSuggestion(value); }}
                  >
                    {value}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
      {useButton && (
        <button
          className="btn btn--submit"
          type="button"
          disabled={allowEmptyQueries ? false : state.value.length === 0}
          onClick={() => { submitGoogleEvent(controller.state.value); controller.submit(); }}
        >
          <span className="btn__label">Search</span>
        </button>
      )}
    </div>
  );
};

export default SearchBox;
